import React from 'react';
import styled from 'styled-components';

import { Dot } from './Components';

const Container = styled.button(({ theme }) => {
  return `
    padding: 5px;
    text-align: left;
    background: ${theme.color.grayscale[1000]}
    width: 350px;
  `;
});

const Label = styled.span(({ theme }) => {
  return `
        font-size: ${theme.type.size.regular};
        font-weight: bold;
        margin-right: 15px;
        

        &.gray {
            color: ${theme.color.grayscale[400]};
        }

        &.red {
            color: ${theme.color.accentTertiary.regular};
        }

        &.yellow {
            color: ${theme.color.accentPrimary.regular}
        }

        &.green {
            color: ${theme.color.tertiary.regular}
        }
    `;
});

const ROWS = [
  {
    label: {
      text: 'NOT STARTED',
      class: 'gray',
    },
    text: 'No remote activity yet',
  },
  {
    label: {
      text: 'ON TRACK',
      class: 'green',
    },
    text: 'Daily remote participation is higher than 51%',
  },
  {
    label: {
      text: 'AT RISK',
      class: 'yellow',
    },
    text: 'Daily remote participation is lower than 51%',
  },
  {
    label: {
      text: 'HIGH RISK',
      class: 'red',
    },
    text: 'Few days remaining to complete 51% goal',
  },
];

const Row = styled.div(({ theme }) => {
  return `
        font-size: ${theme.type.size.small};
        color: ${theme.color.grayscale[200]};
        margin-bottom: 20px;
    `;
});

const printRows = () => {
  return ROWS.map((row) => {
    return (
      <Row>
        <Label className={row.label.class}>
          <Dot>•</Dot>
          {row.label.text}
        </Label>
        <div>{row.text}</div>
      </Row>
    );
  });
};

// Create the Button component
const TooltipContent: React.FC = () => {
  return <Container>{printRows()}</Container>;
};

export default TooltipContent;
